import React, { useState } from 'react';

import moment from 'moment';
import DayPicker, { DateUtils } from 'react-day-picker';
import { Colors } from '../../themes/colors';
import CustomPortal from './CustomPortal';


export const DateRangePicker = ({ label, placeholder, value, onChange }) => {
  const [show, setShow] = useState(false);
  const [range, setRange] = useState(value);

  const formatDateRange = (row = {}) => {
    const { from, to } = row;
    const now = moment();
    const dateStart =
      moment(from).year() === now.year()
        ? moment(from).format('MM/DD')
        : moment(from).format('YYYY/MM/DD');
    const dateEnd =
      moment(to).year() === now.year()
        ? moment(to).format('MM/DD')
        : moment(to).format('YYYY/MM/DD');
  
    return `${dateStart} - ${dateEnd}`;
  };

  const handleOpen = () => {
    setShow(true);
    setRange(value);
  };

  const handleClose = () => {
    setShow(false);
    setRange(value);
  };

  const handleOk = () => {
    onChange(range);
    setShow(false);
  };

  const handleDayClick = (day) => {
    const newRange = DateUtils.addDayToRange(day, range);
    setRange(newRange);
  };

  const valueDisplay =
    value.from && value.to
      ? `${formatDateRange({ from: value.from, to: value.to })}`
      : '';

  return (
    <div style={styles.formContainer}>
      {label && <span style={{ fontWeight: 'bold' }}>{label}:</span>}
      <input
        className="custom-select custom-select-lg"
        style={styles.inputStyle}
        value={valueDisplay}
        onClick={handleOpen}
        placeholder={placeholder}
      />
      {show && (
        <CustomPortal
          title={label || 'Date Range'}
          textStyle={{ textAlign: 'center' }}
          cancelText="Close"
          submitText="Select"
          submitPressed={handleOk}
          cancelPressed={handleClose}
        >
          <DayPicker
            className="Selectable"
            disabledDays={{
              before: moment().toDate(),
            }}
            selectedDays={[range.from, { from: range.from, to: range.to }]}
            modifiers={{ start: range.from, end: range.to }}
            onDayClick={handleDayClick}
          />
        </CustomPortal>
      )}
    </div>
  );
};

const styles = {
  formContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 5,
    width: 200,
  },
  formWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  inputStyle: {
    width: 154,
    height: 30,
    boxShadow: 'none',
    borderRadius: 2,
    borderColor: Colors.border,
  },
};
